import { Component, Input } from '@angular/core';
import { PopupNotificationService } from '../../../Services/popup-notification.service';
import { MembersService } from '../../../Services/members.service';
import { ActivityHistory, Branch, Lookups, Patient, PopupModelReturn, PopupSetupModel, Roles, Staff } from '../../../AllTableClasses';
import { LookupsService } from '../../../Services/lookups.service';
import { StaffService } from '../../../Services/staff.service';
import { SchedulerService } from '../../../Services/scheduler.service';
import { Subject, takeUntil } from 'rxjs';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-staff-setup-popup',
  templateUrl: './staff-setup-popup.component.html',
  styleUrl: './staff-setup-popup.component.scss'
})
export class StaffSetupPopupComponent {

  private destroy$ = new Subject<void>();

  popup: PopupSetupModel | null = null;
  popupReturn: PopupModelReturn = new PopupModelReturn();

  public submitted: boolean = false;

  @Input() Data!: Staff;
  public staffMember: Staff = new Staff();
  public provinces: Array<Lookups> = new Array<Lookups>();
  public genders: Array<Lookups> = new Array<Lookups>();
  public titles: Array<Lookups> = new Array<Lookups>();
  public Name!: string;
  public departments: Array<Roles> = new Array<Roles>();
  public branches: Array<Branch> = new Array<Branch>();
  public staffList: Array<Staff> = new Array<Staff>();

  public staffMemberError: boolean = false;
  public DepartmentError: boolean = false;
  public BranchError: boolean = false;

  public activityHistory: Array<ActivityHistory> = new Array<ActivityHistory>();
  constructor(
    private popupNotificationService: PopupNotificationService,
    //private membersService: MembersService,
    private lookupService: LookupsService,
    private staffService: StaffService,
    private schedulerService: SchedulerService,

  ) { }

  ngOnInit(): void {
    this.popupNotificationService.staffNotification$.pipe(takeUntil(this.destroy$)).subscribe((popup: PopupSetupModel | null) => {
      this.popup = popup;
      if (this.popup)
      {
        this.ProvinceGet();
        this.GenderGet();
        this.TitleGet();
        this.DepartmentGet();
        this.StaffGet();
        this.activityHistory = new Array<ActivityHistory>();
        this.staffMember = new Staff();
        this.staffMember = this.popup.Data;
        this.submitted = false;
        if (popup?.Data.Guid)
        {
          this.StaffMemberGetByGuid();
        }
      }
      else
      {
        return;
      }
    });
  }

  public StaffGet() {
    this.staffService.StaffSearch("", false, null, null, null, (data) => {
      if (data.Success) {
        this.staffList = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public StaffMemberGetByGuid() {
    this.staffService.StaffGetByGuid(this.popup?.Data.Guid, (data) => {
      if (data.Success) {
        this.staffMember = data.Data;
        this.ActivityHistoryGet();
        if (this.staffMember.ProvinceID) {
          this.BranchGetByProvinceID();          
        }
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public ActivityHistoryGet() {
    this.staffService.ActivityHistoryGet(this.staffMember.ID, (data) => {
      if (data.Success) {
        this.activityHistory = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public DepartmentGet() {
    this.schedulerService.RolesGet((data) => {
      if (data.Success) {
        this.departments = JSON.parse(data.Data);
      }
      else {

      }
    }, (error) => { })
  }

  public ProvinceGet() {
    this.lookupService.ProvinceGet((data) => {
      if (data.Success) {
        this.provinces = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public BranchGetByProvinceID() {
    this.schedulerService.BranchGetByProvinceID(this.staffMember.ProvinceID, (data) => {
      if (data.Success) {
        this.branches = JSON.parse(data.Data);
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public ChangeStaffBranch() {
    this.staffMember.BranchID = null;
    this.BranchGetByProvinceID();
   }

  public GenderGet() {
    this.lookupService.GenderGet((data) => {
      if (data.Success) {
        this.genders = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }
  public TitleGet() {
    this.lookupService.TitleGet((data) => {
      if (data.Success) {
        this.titles = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public onSubmit(form: NgForm): void {
    this.submitted = true;
    this.staffMemberError = false;
    this.DepartmentError = false;
    this.BranchError = false;
    if (!this.staffMember.AgentID) {
      this.staffMemberError = true;
    }
    if (!this.staffMember.BranchID) {
      this.BranchError = true;
    }
    if (!this.staffMember.RoleID) {
      this.DepartmentError = true;
    }
    if (this.staffMemberError == false && this.BranchError == false && this.DepartmentError == false && form.valid) {
      this.ButtonClick();
    } else {
      console.log('Form is not valid');
    }
  }

  ButtonClick() {
    if (this.popup?.Button) {
      this.submitted = true;
      this.popupReturn.Result = this.popup.Button.Result;
      this.staffMember.Active = true;
      this.popupReturn.Data = this.staffMember;
      this.clearPopup();
      this.popupNotificationService.ResolveStaffPopup(this.popupReturn);
    }
    this.submitted;
  }
  AltButtonClick() {
    if (this.popup?.AltButton) {
      this.popupReturn.Result = this.popup.AltButton.Result;
      this.clearPopup();
      this.popupNotificationService.ResolveStaffPopup(this.popupReturn);
    }
  }
  PopupEvent(event: string) {
    if (event === 'close') {
      this.popupReturn.Result = 'close';
      this.clearPopup();
      this.popupNotificationService.ResolveStaffPopup(this.popupReturn);
    }

  }

  clearPopup() {
    this.popup = null;
    this.staffMemberError = false;
    this.DepartmentError = false;
    this.BranchError = false;
    this.staffMember = new Staff();
    this.activityHistory = new Array<ActivityHistory>();
  }

  ngOnDestroy(): void {
    // Emit and complete the destroy$ Subject to clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
